import { useState } from 'react'

export const useHistory = () => {

    const [historial, setHistorial] = useState<any[]>([])
    const [errorQuantities, setErrorQuantities] = useState(0)
    const [showHistory, setShowHistory] = useState(false)

    return {
        historial,
        errorQuantities,
        showHistory,
        setShowHistory,
        setErrorQuantities,
        setHistorial,
    }
}
